<h1 mat-dialog-title>{{ 'Order.MassEditWorkerRealizationDateInfo' | translate }}</h1>
<div mat-dialog-content>
  <p>{{ 'Order.MassEditWorkerRealizationDateAdditional' | translate : { workerOrderItemCount: elementsCount } }}</p>

  <mat-calendar [(selected)]="selectedDate" (selectedChange)="setDate($event)" [minDate]="minDate" [maxDate]="maxDate"></mat-calendar>
</div>
<div mat-dialog-actions class="row">
  <div class="col">
    <button mat-button class="float-left" (click)="onClose()">{{ 'Cancel' | translate }}</button>
    <button mat-raised-button class="float-right" color="primary" (click)="onSave()">{{ 'Save' | translate }}</button>
  </div>
</div>
